import { WidgetLineGraph } from '../Widgets';
import { connect } from 'react-redux';
import { getConversionData } from '../../redux/actions/conversion';
import { sumByField, formatDateFromRange } from '../../helpers';

const mapStateToProps = (state, ownProps) => ({
  id: 'WidgetVisits',
  className: ownProps.className,
  width: ownProps.width,
  height: ownProps.height,
  graph: state.conversion.WidgetVisits && state.conversion.WidgetVisits.data && state.filter.filters.startDate && state.filter.filters.endDate ? Object.values(state.conversion.WidgetVisits.data.reduce((acc, curr) => ({
    nv: [...acc.nv, {value: curr.nv, key: formatDateFromRange(curr.dt, state.filter.filters), label:'nv', dt:curr.dt}],
    nvm: [...acc.nvm, {value: curr.nvm, key: formatDateFromRange(curr.dt, state.filter.filters), label:'nvm', dt:curr.dt}]
  }), {
    nv: [],
    nvm: []
  })) : [],
  exportData: state.conversion.WidgetVisits && state.conversion.WidgetVisits.data && state.filter.filters.startDate && state.filter.filters.endDate ? state.conversion.WidgetVisits.data.map(item => ({
    date: item.dt,
    "Visits": item.nv,
    "Identified Visits": item.nvm
  })) : [],
  info: state.conversion.WidgetVisits && state.conversion.WidgetVisits.data ? [{
    amount: (sumByField(state.conversion.WidgetVisits.data, 'nvm') / sumByField(state.conversion.WidgetVisits.data, 'nv')) * 100,
    type: 'percentage',
    description: "Identified Visitors"
  }, {
    amount: state.conversion.WidgetVisits.data ? sumByField(state.conversion.WidgetVisits.data, 'nv') : 0,
    description: "# Visits"
  }] : [],
  filters: {
    oc: state.filter.filters.oc,
    srvcId: state.filter.filters.service,
    startDate: state.filter.filters.startDate,
    endDate: state.filter.filters.endDate,
    tz: state.filter.filters.tz
  },
  keys: ['Visits', 'Identified Visits'],
  colorScheme: ownProps.colorScheme,
  title: ownProps.title,
  onZoom: ownProps.onZoom,
  dataLoaded: state.conversion.WidgetVisits
    && state.conversion.WidgetVisits.loaded,
  filtersLoaded: state.filter.filters.oc
    && state.filter.filters.service
    && state.filter.filters.startDate
    && state.filter.filters.endDate,
  loaded: state.conversion.WidgetVisits
    && state.conversion.WidgetVisits.loaded
    && state.filter.filters.oc
    && state.filter.filters.service
    && state.filter.filters.startDate
    && state.filter.filters.endDate,
  shouldLoadData: !state.conversion.WidgetVisits || (!state.conversion.WidgetVisits.loaded && !state.conversion.WidgetVisits.loading && !state.conversion.WidgetVisits.error),
  drillOptions: ['Category', 'OS', 'Partner', 'Page', 'Campaign'],
  drillData: [
    {
      label: 'Category',
      param: 'cat',
      onClick: ownProps.drillClick,
      widgetType: 'WidgetPieDrillVisits',
      widgetTitle: 'Visits Data - Category'
    },
    {
      label: 'OS',
      param: 'os',
      onClick: ownProps.drillClick,
      widgetType: 'WidgetPieDrillVisits',
      widgetTitle: 'Visits Data - OS'
    },
    {
      label: 'Partner',
      param: 'partnerId',
      onClick: ownProps.drillClick,
      widgetType: 'WidgetPieDrillVisits',
      widgetTitle: 'Visits Data - Partner'
    },
    {
      label: 'Page',
      param: 'pageId',
      onClick: ownProps.drillClick,
      widgetType: 'WidgetPieDrillVisits',
      widgetTitle: 'Visits Data - Page'
    },
    {
      label: 'Campaign',
      param: 'campaignId',
      onClick: ownProps.drillClick,
      widgetType: 'WidgetPieDrillVisits',
      widgetTitle: 'Visits Data - Campaign'
    }
  ],
  customFilter: true,
  customFilterAcceptedParams: ['pageId', 'os', 'campaignId', 'flowId', 'partnerId']
})

const mapDispatchToProps = { fetchData: getConversionData };

export default connect(mapStateToProps, mapDispatchToProps)(WidgetLineGraph)



// WEBPACK FOOTER //
// ./src/components/ConnectedWidgets/WidgetVisitsConnected.js